module.exports = __webpack_public_path__ + "img/banner-bg-mobile.5dcafa43.png";